import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';
import ApiReducer from './ApiReducer';
import CurrentUserReducer from './CurrentUserReducer';
import PendingExamsReducer from './PendingExamsReducer';
import ClosedExamsReducer from './ClosedExamsReducer';
import SentExamsReducer from './SentExamsReducer';
import NotSentExamsReducer from './NotSentExamsReducer';
import AnswerReducer from './AnswerReducer';
import McAnswerReducer from './McAnswerReducer';
import AnswerGradersReducer from './AnswerGradersReducer';
import AnswerReviewersReducer from './AnswerReviewersReducer';
import AssignationsReducer from './AssignationsReducer';
import TestsReducer from './TestsReducer';
import ExamsReducer from './ExamsReducer';
import StudentsReducer from './StudentsReducer';
import ExamTestsReducer from './ExamTestsReducer'
import GradingMatricesReducer from './GradingMatricesReducer';
import ReportsReducer from './ReportsReducer'
import TextsReducer from './TextsReducer';
import UsersReducer from './UsersReducer';
import UsersGradingMatricesReducer from './UsersGradingMatricesReducer';
import QuestionariesReducer from './QuestionariesReducer';
import ExamQuestionariesReducer from './ExamQuestionariesReducer';
import TenantReducer from './TenantReducer';
import SearchesReducer from './SearchesReducer';
import AnswerBankReducer from './AnswerBankReducer';
import AuditsReducer from './AuditsReducer';
import SuperMatricesReducer from './SuperMatricesReducer';
import ProcessesReducer from './ProcessesReducer';
import VideosReducer from './VideosReducer';
import ApwindowsReducer from './ApwindowsReducer';
import ApwindowUsersReducer from './ApwindowUsersReducer';
import LabelReducer from './LabelReducer';
import LabelAnswerReducer from './LabelAnswerReducer';
import ThemeReducer from './ThemeReducer';
import GradingCritetionOptionReducer from './GradingCritetionOptionReducer';
import GradingCriteriaReducer from './GradingCriteriaReducer';
import ImpersonationReducer from './ImpersonationReducer';

// Permite unificar la parte del estado de la que cada reducer se encarga
const rootReducer = combineReducers({
  api: ApiReducer,
  answer: AnswerReducer,
  answerBank: AnswerBankReducer,
  audits: AuditsReducer,
  answerGraders: AnswerGradersReducer,
  answerReviewers: AnswerReviewersReducer,
  apwindows: ApwindowsReducer,
  apwindowUsers: ApwindowUsersReducer,
  assignations: AssignationsReducer,
  closedExams: ClosedExamsReducer,
  currentUser: CurrentUserReducer,
  exams: ExamsReducer,
  examQuestionaries: ExamQuestionariesReducer,
  examTests: ExamTestsReducer,
  form: formReducer,
  gradingMatrices: GradingMatricesReducer,
  gradingCriterias: GradingCriteriaReducer,
  gradingCriterionOptions: GradingCritetionOptionReducer,
  impersonation: ImpersonationReducer,
  labels: LabelReducer,
  labelAnswers: LabelAnswerReducer, 
  mcAnswer: McAnswerReducer,
  notSentExams: NotSentExamsReducer,
  pendingExams: PendingExamsReducer,
  processes: ProcessesReducer,
  questionaries: QuestionariesReducer,
  reports: ReportsReducer,
  search: SearchesReducer,
  sentExams: SentExamsReducer,
  students: StudentsReducer,
  superMatrices: SuperMatricesReducer,
  tenant: TenantReducer,
  themes: ThemeReducer,
  tests: TestsReducer,
  texts: TextsReducer,
  users: UsersReducer,
  usersGradingMatrices: UsersGradingMatricesReducer,
  videos: VideosReducer
});

export default rootReducer;
